export enum Mission {
  RECHERCHE = 'RECHERCHE',
  DIFFUSION = 'DIFFUSION',
  EXPERTISE = 'EXPERTISE',
  COLLECTIONS = 'COLLECTIONS',
  ENSEIGNEMENT = 'ENSEIGNEMENT',
}
